export class WorkerFilters {
    viewTams: boolean;
    viewfamilyAllowance: boolean;
    viewSchoollAllowance: boolean;

}
